( () => {
	'use strict';

	const context = window.westPaw = window.westPaw || {};
	let failedCart;
	let syncPending = false;
	let destroying = false;

	// Rebuy can exist without a published/mounted Smart Cart (including /cart).
	function activeCart() {
		const cart = window.Rebuy?.SmartCart;
		return ! context.isB2B && cart !== failedCart && cart?.status === 'ready'
			&& typeof cart.show === 'function' && document.getElementById( 'rebuy-cart' )
			? cart : null;
	}

	context.isRebuySmartCartActive = () => Boolean( activeCart() );

	function updateCounts( count ) {
		if ( ! Number.isInteger( count ) || count < 0 ) return;
		document.querySelectorAll( 'cart-count' ).forEach( ( badge ) => {
			if ( badge.textContent.trim() !== String( count ) ) badge.textContent = count;
			if ( badge.getAttribute( 'total-items' ) !== String( count ) ) badge.setAttribute( 'total-items', count );
			badge.classList.toggle( 'hidden', count === 0 );
		} );
		document.querySelectorAll( '[data-cart-count-label]' ).forEach( ( label ) => {
			const text = label.dataset.countTemplate.replace( '__COUNT__', count );
			if ( label.textContent !== text ) label.textContent = text;
		} );
	}

	function synchronize() {
		syncPending = false;
		if ( ! document.body ) return;
		const cart = activeCart();
		const wasActive = document.body.classList.contains( 'rebuy-smart-cart-active' );
		document.body.classList.toggle( 'rebuy-smart-cart-active', Boolean( cart ) );
		if ( cart ) {
			// CSS alone would leave the theme's focus trap, overlay and scroll lock active.
			const drawer = document.getElementById( 'DrawerCart' );
			if ( drawer?.classList.contains( 'drawer__open' ) ) drawer.close?.();
			updateCounts( cart.itemCount() );
		} else if ( wasActive ) {
			updateCounts( window.Rebuy?.Cart?.cart?.item_count );
			// Rebuild the fallback drawer using Shopify's current cart, without opening it.
			window.dispatchEvent( new CustomEvent( 'cart:refresh-silent' ) );
		}
	}

	function scheduleSync() {
		if ( syncPending ) return;
		syncPending = true;
		// Run after the theme's cart-count handlers and Rebuy's synchronous updates.
		queueMicrotask( synchronize );
	}

	function onReady( event ) {
		const cart = event?.detail?.smartcart || window.Rebuy?.SmartCart;
		failedCart = undefined;
		if ( context.isB2B && cart && typeof cart.destroy === 'function' && ! destroying ) {
			destroying = true;
			try {
				cart.hide?.();
				cart.destroy();
			} finally {
				document.body?.classList.remove( 'smart-cart--enabled', 'rebuy-cart-visible', 'rebuy-smart-cart-active' );
				destroying = false;
			}
		}
		scheduleSync();
	}

	function openCart( event ) {
		const trigger = event.target.closest?.( '[data-cart-trigger]' );
		if ( ! trigger || ( event.type === 'keyup' && event.code !== 'Enter' ) ) return;
		// Preserve modified clicks on the cart page link.
		if ( event.type === 'click' && ( event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ) ) return;
		const cart = activeCart();
		if ( ! cart ) {
			synchronize();
			return;
		}
		try {
			cart.show();
		} catch ( error ) {
			failedCart = cart;
			synchronize();
			console.warn( 'Unable to open Rebuy Smart Cart; using the theme cart.', error );
			return;
		}
		event.preventDefault();
		event.stopImmediatePropagation();
		scheduleSync();
	}

	document.addEventListener( 'click', openCart, true );
	document.addEventListener( 'keyup', openCart, true );
	document.addEventListener( 'rebuy:smartcart.ready', onReady );
	document.addEventListener( 'rebuy:smartcart.show', ( event ) => {
		if ( context.isB2B ) onReady( event );
		else scheduleSync();
	} );
	[
		'rebuy:cart.ready', 'rebuy:cart.change', 'rebuy:cart.enriched',
		'rebuy:smartcart.hide', 'cart:change', 'cart:replaced', 'shopify:section:load',
	].forEach( ( name ) => document.addEventListener( name, scheduleSync ) );

	function initialize() {
		// Handle Rebuy being ready before this deferred asset executes.
		if ( window.Rebuy?.SmartCart?.status === 'ready' ) onReady();
		else scheduleSync();
		// Rebuy's destroy() has no documented teardown callback. Watch its root and
		// new header badges so removal and section replacement also restore/sync UI.
		new MutationObserver( ( records ) => {
			const relevant = records.some( ( record ) => [ ...record.addedNodes, ...record.removedNodes ].some( ( node ) =>
				node.nodeType === 1 && ( node.matches( '#rebuy-cart, cart-count' ) || node.querySelector( '#rebuy-cart, cart-count' ) )
			) );
			if ( relevant ) scheduleSync();
		} ).observe( document.body, { childList: true, subtree: true } );
	}

	if ( document.readyState === 'loading' ) document.addEventListener( 'DOMContentLoaded', initialize, { once: true } );
	else initialize();
} )();
